import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/taxinvoice.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import downIcon from '../images/download.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import { data } from "react-router";
import CustomerDiv from "../common/customerdiv";
import { getDayWiseAmount } from "../common/mylib";
import excel from '../images/excelicon.png';
import { exportArrayToExcel } from "../common/mylib";

const TaxInvoices=()=>
{
const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");
    const [paymentdata,setPaymentData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [planamount,setPlanAmount]=useState(0);
    const [formData,setFormData]=useState({
        id:0,
        subscriptionid:0,
        billno: "",
        billdate: "",
        billfrom: "",
        billto: "",
        billdetails: "",
        billamount: 0,
        sgstrate: 0,
        cgstrate: 0,
        igstrate: 0,
        totalamt: 0,
        isDeleted: "N",
        fyear: "",
        partyname: "",
        company: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
        mobile: "",
        gstin: "",
        email: ""
    });
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(10);
    const [totalPage,setTotalPage]=useState(0);
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Company", key: "customer", sortable: true},
        { name: "Financial Year", key: "fyear", sortable: true },        
        { name: "GSTIN", key: "gstin", sortable: false },        
        { name: "Bill No", key: "billno", sortable: true }, 
        { name: "Bill Date", key: "billdate", sortable: true }, 
        { name: "From", key: "billfrom", sortable: true },   
        { name: "To", key: "billto", sortable: true },
        { name: "Amount", key: "billamount", sortable: true },
        { name: "Tax", key: "tax", sortable: false },
        { name: "Net Payable", key: "totalamt", sortable: true },      
    ];
    function addSubsriber(event)
    {
        setFormData({
        id:0,
        subscriptionid:0,
        billno: "",
        billdate: "",
        billfrom: "",
        billto: "",
        billdetails: "",
        billamount: 0,
        sgstrate: 0,
        cgstrate: 0,
        igstrate: 0,
        totalamt: 0,
        isDeleted: "N",
        fyear: "",
        partyname: "",
        company: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
        mobile: "",
        gstin: "",
        email: ""
        });
        setShow(true);
    }
    async function saveData(event)
    {
        setMsg("");
        if(window.confirm('Are you sure?'))        {
            
            setProgress(true);
            await apiClient.post("/api/invoice/UpdateTaxInvoice/"+formData.id,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadTransactions();
                        alert("Data Saved Successfully");
                        setFormData({id:0,subscriptionid:0,billno: "",billdate: "",billfrom: "",billto: "",billdetails: "",billamount: 0,sgstrate: 0,cgstrate: 0,igstrate: 0,totalamt: 0,isDeleted: "N",fyear: "",partyname: "",company: "",address: "",state: "",city: "",pincode: "",mobile: "",gstin: "",email: ""});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });   
        }
        setProgress(false);
    }
    async function loadTransactions()
    {
        //console.log("Token:",localStorage.getItem("token"));
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Invoice/GetAllTaxInvoices").then(res=>
        {
            if(res.status==200)
            {
                //console.log("Data:",res.data.data);
                setPaymentData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });        
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>=3)
            {
                let searchResult=paymentdata.filter((e)=>e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.partyname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.billno.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(paymentdata);                
                setPageData(paymentdata.slice(0,pageSize));
            }
            setPage(1);
        } 
        if(event.target.id=="month") //2025-11
        {
            if(event.target.value.length>=3)
            {
                let d1=new Date(event.target.value+"-01");                
                let d2=new Date(d1.getFullYear(),d1.getMonth()+1,1);
                let searchResult=paymentdata.filter((e)=>
                {
                    let d3=new Date(e.billdate.split("T")[0]);                    
                    return d3>=d1 && d3<d2;
                });         
                searchResult.sort((e1,e2)=>
                {
                    let d11=new Date(e1["billdate"]);
                    let d12=new Date(e2["billdate"]);
                    let x=(d11-d12);                    
                    return x;
                });
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));                                
            }
            else
            {
                setDataToDisplay(paymentdata);                
                setPageData(paymentdata.slice(0,pageSize));
            }
            setPage(1);
        }             
    }
    function formValueChanged(event)
    {
        if(event.target.id=="id") setFormData({...formData,id:event.target.value});        
        
        if(event.target.id=="billdetails") setFormData({...formData,state:event.target.value});
        if(event.target.id=="billfrom")
        {
            let amt=getDayWiseAmount(planamount,event.target.value,formData.billto);
            let netamt=Math.round(amt+(amt*0.18));
            setFormData({...formData,billfrom:event.target.value,totalamt:netamt});
        }
        if(event.target.id=="billto")
        {
            let amt=getDayWiseAmount(planamount,formData.billfrom,event.target.value);
            let netamt=Math.round(amt+(amt*0.18));
            setFormData({...formData,billto:event.target.value,totalamt:netamt});
        }                
    }
    function calculateTotal(amt,sgst,cgst,igst)
    {
        let v=Math.round(parseFloat(amt)+ (parseFloat(amt)*(parseFloat(sgst)+parseFloat(cgst)+parseFloat(igst)))/100);
        return isNaN(v)?0:v;
    }
    function deleteInvoice(id)
    {
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            apiClient.post(process.env.REACT_APP_APIURL+"/api/Invoice/DeleteTaxInvoice/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadTransactions();                    
                }
            });
        }
    }    
    async function editInvoice(id)
    {
        let sid=0;
        setProgress(true);
        let obj=paymentdata.find(s=>s.id==id);
        obj.billdate=obj.billdate.split("T")[0];
        obj.billfrom=obj.billfrom.split("T")[0];
        obj.billto=obj.billto.split("T")[0];
        setFormData(obj);                
        sid=obj.subscriptionid;
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Subscription/GetSubscriptionById/"+sid).then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
               setPlanAmount(res.data.data.planamount);                            
            }
        });
        setShow(true);
        setProgress(false);
    }
    function downloadInvoice(id)
    {
        window.open("https://instaaofficeapi-fybmegfwefg9e0ae.canadacentral-01.azurewebsites.net/api/DownloadInvoice/Tax/"+id,"","width=800,height=900");
        //apiClient.get(process.env.REACT_APP_APIURL+"/api/DownloadInvoice/Tax/"+id).then(res=>
       // {
       //     if(res.status==200 && res.data.status=="OK")
       //     {
       //         //setFormData(res.data.data);                
       //         setShow(true);
       //     }
       // });
    }
    function sortData(colname)
    {
        if(colname=="customer")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1.partyname.trim().toLowerCase()>e2.partyname.trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="fyear" || colname=="billno")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="billdate" || colname=="billfrom" || colname=="billto")
        {
            let arr=[...paymentdata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname]);
                let d2=new Date(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="billamount" || colname=="totalamt")
        {
            let arr=[...paymentdata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }        
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadTransactions();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" placeholder="Customer Name/ Company/ Details...." id="searchText" style={{fontSize:'12px',width:'250px'}} onChange={searchData} className="form-control" /></div>                
                <div className="flex-grow-1 text-end">
                    <input type="month" id="month" onChange={searchData} className="form-control form-control-sm" style={{maxWidth:'150px'}} />
                </div>
                <div className="flex-grow-1 text-end"><img onClick={()=>{exportArrayToExcel(dataToDisplay,'TaxInvoices')}} src={excel} style={{width:'30px',marginLeft:'10px',cursor:'pointer'}} /></div>

            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Tax Invoices</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={i}>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}
                            <th>View/Edit</th>  
                            <th>Delete</th>
                            <th>Download</th>                          
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={i}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>
                                {                            
                                    if(ee.key=="customer")
                                    {
                                        return(<td><CustomerDiv cname={e.partyname} company={e.company} address={e.address} email={e.email} mobile={e.mobile} /></td>);
                                    }
                                    else if(ee.key=="billdate" || ee.key=="billfrom" || ee.key=="billto")
                                    {
                                        return(<td>{e[ee.key].split("T")[0].split("-").reverse().join("-")}</td>);                            
                                    }
                                    else if(ee.key=="tax")
                                    {
                                        return(<td>{e.sgstrate+e.cgstrate}%</td>);                            
                                    }
                                    else
                                    {
                                        return(<td>{e[ee.key]}</td>);                            
                                    }
                                }
                                )}
                                <td className="text-center"><img onClick={()=>editInvoice(e.id)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>deleteInvoice(e.id)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>downloadInvoice(e.id)} src={downIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="1"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="10" className="text-end">
                                Total Amount: &#8377; {Math.round(dataToDisplay.reduce((sum,item)=>sum+parseFloat(item.billamount),0))}<br/>
                                Total Tax: &#8377; {Math.round(dataToDisplay.reduce((sum,item)=>sum+(parseFloat(item.billamount)*(parseFloat(item.cgstrate)+parseFloat(item.sgstrate)))/100,0))}<br/>
                                Net Amount: &#8377; {Math.round(dataToDisplay.reduce((sum,item)=>sum+parseFloat(item.totalamt),0))}
                            </th>
                            <th colSpan="3" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="14">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                        
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Tax Invoice</div>
                                        <div className="row">
                                            <input type="text" id="id" onChange={formValueChanged} value={formData.id} className="form-control mt-2 d-none"/>
                                            <div className="form-group"><input type="text" id="name" onChange={formValueChanged} value={formData.partyname} className="form-control  form-control-sm mt-2" readOnly  />    </div>                                
                                            <div className="form-group"><input type="text" id="company" onChange={formValueChanged} value={formData.company} className="form-control  form-control-sm mt-2" readOnly  /></div>                                            
                                            <div className="form-group"><input type="text" id="address" onChange={formValueChanged} value={formData.address} className="form-control  form-control-sm mt-2" readOnly /></div>
                                            <div className="form-group"><input type="text" id="gstin" onChange={formValueChanged} value={formData.gstin} className="form-control  form-control-sm mt-2"  readOnly /> </div>                                   
                                            <div className="form-group col-6">
                                                <label>Bill No</label>
                                                <input type="text" id="billno" onChange={formValueChanged} value={formData.billno} className="form-control form-control-sm mt-2" readOnly  /></div>
                                            <div className="form-group col-6">
                                                <label>Bill Date</label>
                                                <input type="date" id="billdate" onChange={formValueChanged} value={formData.billdate} className="form-control form-control-sm mt-2" /></div>
                                            <div className="form-group col-6">
                                                <label>Bill From</label>
                                                <input type="date" id="billfrom" onChange={formValueChanged} value={formData.billfrom} className="form-control form-control-sm mt-2"  /></div>
                                            <div className="form-group col-6">
                                                <label>Bill Upto</label>
                                                <input type="date" id="billto" onChange={formValueChanged} value={formData.billto} className="form-control form-control-sm mt-2" /></div>
                                            <div className="p-3 mt-2">
                                                <table className="table table-bordered shadow rounded" style={{fontSize:'12px'}}>
                                                    <tbody>                                                    
                                                        <tr><td rowSpan="4"><textarea rows="8" id="billdetails" onChange={formValueChanged} value={formData.billdetails} className="form-control mt-2" ></textarea></td><td>Amount</td><td><input type="text" style={{textAlign:'right'}} id="billamount" onChange={formValueChanged} value={formData.billamount} className="form-control form-control-sm mt-2" readOnly /></td></tr>
                                                        <tr><td valign="middle" style={{minWidth:'80px'}}>SGST (%)</td><td><input type="text" style={{textAlign:'right'}} id="sgstrate" onChange={formValueChanged} value={formData.sgstrate} className="form-control form-control-sm mt-2" /></td></tr>
                                                        <tr><td valign="middle">CGST (%)</td><td><input type="text" style={{textAlign:'right'}} id="cgstrate" onChange={formValueChanged} value={formData.cgstrate} className="form-control form-control-sm mt-2"  /></td></tr>
                                                        <tr><td valign="middle">IGST (%)</td><td><input type="text" style={{textAlign:'right'}} id="igstrate" onChange={formValueChanged} value={formData.igstrate} className="form-control form-control-sm mt-2"  /></td></tr>
                                                        <tr><td colSpan="2">Net Payable</td><td><input type="text" style={{textAlign:'right'}} id="totalamt" onChange={formValueChanged} value={formData.totalamt} className="form-control form-control-sm mt-2" readOnly /></td></tr>
                                                    </tbody>
                                                </table>  
                                            </div>                                          
                                        </div>
                                    <input type="button" className="btn btn-danger"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default TaxInvoices;